import { FC } from "react";
import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFound: FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center px-4 bg-background">
            <div className="max-w-md w-full text-center space-y-8">
                {/* Error Code */}
                <div className="space-y-3">
                    <h1 className="text-9xl font-semibold text-muted-foreground/20">
                        404
                    </h1>
                    <h2 className="text-2xl font-semibold tracking-tight">
                        Page Not Found
                    </h2>
                    <p className="text-muted-foreground">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                </div>

                {/* Action Button */}
                <div className="pt-4">
                    <Button
                        onClick={() => navigate("/")}
                        size="lg"
                        className="gap-2"
                    >
                        <Home className="h-4 w-4" />
                        Go to Home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
